function AllDonePage() {
    return <h1>All done, get back to gaming!</h1>
}

export default AllDonePage